(($, Drupal, once) => {
  // eslint-disable-next-line no-unused-vars
  function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  Drupal.behaviors['get-quote'] = {
    // eslint-disable-next-line no-unused-vars
    attach: context => {
      $(once('get-quote', 'form.postal-code-entry__form select', context))
        .each(function quoteBoxFeautures() {
          let placeHolderValue = '';
          let defaultValue = '';
          $('option', $(this)).each(function quoteBoxRemoveEmptyOption() {
            if ($(this).val() === 'all') {
              placeHolderValue = $(this).text();
              $(this).remove();
            }
          });
          $(this)
            .prepend('<option selected></option>')
            .select2({
              width: '100%',
              placeholder: placeHolderValue,
              minimumResultsForSearch: -1,
            })
        });

      $(once('get-quote', '#postalCode', context))
        .focus();
      /*
      const cid = getQueryVariable('cid');
      if (cid) {
        const rootDomain = document.location.hostname
          .split('.')
          .reverse()
          .splice(0, 2)
          .reverse()
          .join('.');
        document.cookie = `cid=${cid};path=/;domain=${rootDomain};expires=0`;
      }
    */
    },
  };
})(jQuery, Drupal, once);
